/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import StaticInfoTemplates from './StaticInfoTemplates';

/**
 * The StaticInfo model module.
 * @module model/StaticInfo
 * @version 1.0.0
 */
class StaticInfo {
    /**
     * Constructs a new <code>StaticInfo</code>.
     * @alias module:model/StaticInfo
     */
    constructor() { 
        
        StaticInfo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StaticInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StaticInfo} obj Optional instance to populate.
     * @return {module:model/StaticInfo} The populated <code>StaticInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StaticInfo();

            if (data.hasOwnProperty('templates')) {
                obj['templates'] = StaticInfoTemplates.constructFromObject(data['templates']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/StaticInfoTemplates} templates
 */
StaticInfo.prototype['templates'] = undefined;






export default StaticInfo;

